import React, { createContext, useContext, useState, useCallback } from "react";

interface ChatContextValue {
  open: boolean;
  toggle: () => void;
  close: () => void;
}

const ChatContext = createContext<ChatContextValue>({
  open: false,
  toggle: () => {},
  close: () => {},
});

export function ChatProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen((v) => !v), []);
  const close = useCallback(() => setOpen(false), []);

  return (
    <ChatContext.Provider value={{ open, toggle, close }}>
      {children}
    </ChatContext.Provider>
  );
}

export function useChat() {
  return useContext(ChatContext);
}
